
import { defineComponent, onMounted, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Alert from '@/components/ui-elements/Alert.vue';
import Button from '@/components/ui-elements/form/Button.vue';
import Form from '@/components/ui-elements/form/Form';
import Input from '@/components/ui-elements/form/Input.vue';
import LoaderIcon from '@/components/ui-elements/icons/LoaderIcon.vue';
import useHttp from '@/hooks/useHttp';
import useTimestamp from '@/hooks/useTimestamp';
import { useUserStore } from '@/store';

export default defineComponent({
	components: {
		Alert,
		Button,
		Form,
		Input,
		LoaderIcon,
	},
	setup() {
		const { loading, post } = useHttp();
		const { unix } = useTimestamp();
		const { push } = useRouter();
		const { params } = useRoute();
		const userStore = useUserStore();

		const alert = reactive({
			display: false,
			message: '',
			type: '',
		});
		const emailSent = ref(false);
		const expired = ref(false);
		const form = reactive({
			verify: {
				rules: ['required', 'max:6'],
				value: '',
			},
		});
		const valid = ref(false);

		onMounted(() => {
			expired.value = unix() > unix(userStore.login.verify.expires_at);
		});

		const submitVerify = async () => {
			const data = {
				path: `auth/submit-verify`,
				params: {
					id: userStore.user.user_id,
					token: params.token,
					verify: form.verify.value,
				},
			};
			const response = await post(data);

			if (response.success) {
				push({ name: 'home' });
				return true;
			}

			expired.value = response.error.includes('expired');
			alert.message = response.error;
			alert.type = 'error';
			alert.display = true;
		};

		const resendEmail = async () => {
			const data = {
				path: `auth/resend-verify`,
				params: {
					id: userStore.user.user_id,
					token: params.token,
				},
			};
			const response = await post(data);

			if (response.success) {
				alert.display = true;
				alert.message =
					'Email sent! If email is not in your inbox, check your spam folder.';
				alert.type = 'success';
				emailSent.value = true;
			} else {
				alert.display = true;
				alert.message = 'Unable to resend email at this time';
				alert.type = 'error';
			}
		};

		return {
			alert,
			emailSent,
			expired,
			form,
			loading,
			resendEmail,
			submitVerify,
			valid,
		};
	},
});
